const jwt = require("jsonwebtoken");
const secret = "4a8%a5de]4b92#eb0d97d4f$898516[4";
const origin = "zswlApp";
const algorithm = "HS256";

export const newSign = (accountId) => {
  return jwt.sign({ data: { account_id: accountId, origin } }, secret, {
    expiresIn: "1 year",
  });
};

export const JWTverify = (token) => {
  return jwt.verify(token, secret, (err, decoded) => {
    if (err) {
      console.log("token 已经失效");
      return false;
    } else {
      console.log(`token is ${JSON.stringify(decoded)}`);
      return decoded;
    }
  });
};

export const JWTdecode = (token) => {
  return jwt.decode(token);
};
